import { render } from "./Letterbox.vue?vue&type=template&id=58a01e32&scoped=true"
import script from "./Letterbox.vue?vue&type=script&lang=js"
export * from "./Letterbox.vue?vue&type=script&lang=js"

import "./Letterbox.vue?vue&type=style&index=0&id=58a01e32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a01e32"]])

export default __exports__